import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import T from 'i18n-react';
import Link from 'next/link';

import { Button } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import { WithAccountPermitsChecker } from 'Controllers/AccountPermitsChecker/AccountPermitsChecker.helpers';
import { triggerAccountEmptyViewNoResultsCTAClick } from 'Services/analytics/events';
import { applyCypressData } from 'Utilities/helpers';
import useVehicleListButtonConfig from 'Utilities/hooks/vehicleList/useVehicleListButtonConfig';
import proPropTypes from 'Utilities/proPropTypes';
import ROUTES from 'Utilities/routes';

import styles from './AccountEmptyView.module.scss';

T.setTexts(require('Components/texts.json'));

const AccountEmptyView = ({
	buttonLabelTextKey = '',
	icon: Icon,
	keywordQuery = '',
	notFoundTextKey = '',
	showButton,
	slug = '',
	translateTarget,
}) => {
	const translateBase = 'account.emptyView';
	const { as, href } = useVehicleListButtonConfig();
	const translateKey = `${translateBase}.${translateTarget}`;

	const notFoundText = T.translate(`${translateBase}.${notFoundTextKey}`);

	return (
		<div className={cx(styles.accountEmptyView)}>
			{React.cloneElement(Icon, { className: styles.icon })}
			<h3 className={styles.header} {...applyCypressData(cypressIds.accountDataGrid.emptyState.header)}>
				{T.translate(`${translateKey}.header`, {
					keywordQuery,
				})}
			</h3>
			<p className={styles.text}>
				{T.translate(`${translateKey}.text`, {
					link: (
						<Link shallow className={styles.link} href="/account/purchases/complete">
							{T.translate(`${translateKey}.link`)}
						</Link>
					),
					notFound: notFoundText,
				})}
			</p>
			{showButton ? (
				<Link legacyBehavior passHref as={as} href={href}>
					<Button
						data-thc-button
						fullWidth
						as="a"
						icon="chevron"
						onClick={() => {
							triggerAccountEmptyViewNoResultsCTAClick({
								buttonLabel: T.translate(`${translateBase}.${buttonLabelTextKey}`),
								slug,
								url: ROUTES.VEHICLE_LIST.as(),
							});
						}}
						{...applyCypressData(cypressIds.buttons.accountEmptyState)}
						label={T.translate(`${translateBase}.${buttonLabelTextKey}`)}
					/>
				</Link>
			) : null}
		</div>
	);
};

AccountEmptyView.propTypes = {
	buttonLabelTextKey: PropTypes.string,
	icon: PropTypes.node.isRequired,
	keywordQuery: PropTypes.string,
	notFoundTextKey: PropTypes.string,
	permits: proPropTypes.accountPermitsChecker.isRequired,
	showButton: PropTypes.bool.isRequired,
	slug: PropTypes.string,
	translateTarget: PropTypes.string.isRequired,
};

export default WithAccountPermitsChecker()(AccountEmptyView);
